import { motion } from 'motion/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function FertilityBar({ score }: { score: number }) {
  const { t } = useTranslation();
  const [animatedScore, setAnimatedScore] = useState(0);

  useEffect(() => {
    const timeout = setTimeout(() => setAnimatedScore(score), 100);
    return () => clearTimeout(timeout);
  }, [score]);

  return (
    <div className="sticky top-0 z-50 w-full bg-stone-50/80 backdrop-blur-xl border-b border-stone-200/50 px-6 py-5">
      <div className="max-w-md mx-auto flex flex-col gap-3">
        <div className="flex justify-between items-end">
          <h2 className="text-xs font-semibold text-stone-500 uppercase tracking-widest">{t('fertility.label')}</h2>
          <span className="text-3xl font-bold tracking-tighter text-stone-900">{animatedScore}%</span>
        </div>
        <div className="h-2.5 w-full bg-stone-200/50 rounded-full overflow-hidden shadow-inner">
          <motion.div
            className="h-full bg-gradient-to-r from-emerald-400 to-emerald-500 rounded-full shadow-[0_0_10px_rgba(16,185,129,0.4)]"
            initial={{ width: 0 }}
            animate={{ width: `${animatedScore}%` }}
            transition={{ duration: 1.2, ease: [0.25, 1, 0.5, 1] }}
          />
        </div>
      </div>
    </div>
  );
}
